import { render, staticRenderFns } from "./OrdenVentaShow.vue?vue&type=template&id=35d1c3b7&scoped=true&"
import script from "./OrdenVentaShow.vue?vue&type=script&lang=js&"
export * from "./OrdenVentaShow.vue?vue&type=script&lang=js&"
import style0 from "./OrdenVentaShow.vue?vue&type=style&index=0&id=35d1c3b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1c3b7",
  null
  
)

export default component.exports